export default {
  namespaced: true,
  assigned_regions: {
    title: "Regiões atribuídas",
    single: "região atribuída",
    all: "todas as regiões atribuídas",

    current_assignment: "atribuição atual",
    schedule_regions: "programar regiões",
    change: "alterar",
    change_now: "alterar agora",

    region: "região",
    regions: "regiões",
    sector: "setor",
    sectors: "setores",

    analyst: "analista",
    supervisor: "supervisor",
    change_supervisor: "alterar supervisor",
    change_sectors: "alterar regiões",

    scheduled: "programado",
    programmed: "programado",
    manual_change: "alteração manual",

    init_date: "data de início",
    end_date: "data de término",
    active_at: "ativo em",
    active_at_help: "Filtra atribuições ativas em uma data e hora específicas.",
    since: "desde",

    select_supervisor: "selecione um supervisor",
    select_sector: "selecione uma região",
    select_sectors: "selecione regiões",
    select_analyst: "selecione um analista",

    supervisor_optional: "O supervisor é opcional.",
    no_supervisor: "sem supervisor atribuído",
    no_regions: "sem regiões atribuídas",

    effective_assignment: "atribuição efetiva",
    assignment_history: "histórico de atribuições",
    programmed_assignment: "atribuição programada",
    current_supervisor: "supervisor atual",
    current_regions: "regiões atuais",

    save_programmed: "salvar atribuição programada",
    save_change: "salvar alteração",

    messages: {
      created: "Atribuição criada com sucesso.",
      updated: "Atribuição atualizada com sucesso.",
      deleted: "Atribuição removida com sucesso.",
      changed: "Atribuição alterada com sucesso.",
      closed: "A alteração atual foi encerrada com sucesso.",
      load_error: "Erro ao carregar atribuições.",
      save_error: "Erro ao salvar a atribuição.",
      delete_error: "Erro ao remover a atribuição.",
      change_error: "Erro ao alterar a atribuição.",
      required_supervisor: "Selecione um supervisor.",
      required_sector: "Selecione pelo menos uma região.",
    },
  },
};
